<template>
  <div>
    <div style="background-color: #1d2024">
      <color-picker :color="color" @changeColor="changeColor"></color-picker>
      <v-btn small @click="closeColor">OK</v-btn>
    </div>
  </div>
</template>

<script>
  import colorPicker from "@caohenghu/vue-colorpicker";
  export default {
      name: "SelectColor",
      components:{
        colorPicker,
      },
      data(){
        return{
          color : '#59c7f9',
        }
      },
      computed: {

      },
      methods: {
        changeColor(color) {
          this.color = color.hex;
        },
        closeColor(){
          this.$emit("update", this.color);
        }
      },
    }
</script>

<style scoped>

</style>
